import * as constants from './constants';

export const setPopupStatus = state => ({type: constants.SET_POPUP_STATUS, payload: state});